import {
  faClock,
  faClose,
  faHeart,
  faLocationDot,
  faShareNodes,
  faSpinner,
  faStar,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { defaultUserImg, rightAngleImg } from "../../Constants/Images";
import ThumnailImageSlider from "../ThumnailImageSlider";
import { SpaceTypes } from "../../Constants/Interfaces";
import { useNavigate } from "react-router";
import { faHeart as faHeartR } from "@fortawesome/free-regular-svg-icons";
import { toggleFavoriteAction } from "../../Services/Store/Actions/SpaceActions";
import { useDispatch, useSelector } from "react-redux";
import {
  formatArea,
  formatSpaceRate,
  hasSpaceRate,
  showToast,
  SPACE_RATE_UNAVAILABLE_LABEL,
  SPACE_RATE_UNAVAILABLE_HELP_LONG,
} from "../../utils/helpers";
import useAuth from "../../Hooks/useAuth";
import ShareSpaceModal from "./ShareSpaceModal";
import { webSiteUrl } from "../../utils/env";

interface SpaceDetailsType {
  show: boolean;
  item: SpaceTypes & { id: string };
  closeModal: Function;
}

const SpotDetailsModal: React.FC<SpaceDetailsType> = ({
  show,
  item,
  closeModal,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoggedIn, user } = useAuth();
  const userFavSpaces = useSelector((state: any) => state.auth.favorites);

  const [descReadMore, setDescReadMore] = useState(false);
  const [favLoading, setFavLoading] = useState(false);
  const [shareModal, setShareModal] = useState(false);

  const sliderImgs = item && item.media ? item.media : undefined;

  const toggleFavorite = (id: string) => {
    if (!favLoading) {
      setFavLoading(true);

      toggleFavoriteAction({ spaceId: id }, dispatch)
        .then((res) => {
          console.log("RES:", res);
          showToast(res.type, res.message);
        })
        .catch((err) => {
          console.log("ERR:", err);
          showToast("error", err.message);
        })
        .finally(() => setFavLoading(false));
    }
  };

  const redirectTo = () => {
    navigate(`/space/${item.id}`);
  };

  return (
    <Modal
      show={show}
      onHide={() => closeModal()}
      className="space-details-modal-wrapper"
    >
      <span className="close-btn as-link" onClick={() => closeModal()}>
        <FontAwesomeIcon icon={faClose} />
      </span>

      <div className="row">
        <div className="col-md-6 col-sm-6 col-xs-12">
          <div className="space-details-img-slider">
            <ThumnailImageSlider images={sliderImgs} />
          </div>
        </div>

        <div className="col-md-6 col-sm-6 col-xs-12">
          <div className="space-details-content">
            <div className="space-content-heading mb-3">
              <h3>{item.name}</h3>

              <div className="sharing-icons mb-0">
                <span
                  className={
                    item && userFavSpaces && userFavSpaces.includes(item.id)
                      ? "active as-link action-icon"
                      : "as-link action-icon"
                  }
                  onClick={() => {
                    if (isLoggedIn) {
                      toggleFavorite(item.id);
                    } else {
                      redirectTo();
                    }
                  }}
                >
                  {favLoading && <FontAwesomeIcon icon={faSpinner} spin />}
                  {!favLoading && (
                    <FontAwesomeIcon
                      icon={
                        item && userFavSpaces && userFavSpaces.includes(item.id)
                          ? faHeart
                          : faHeartR
                      }
                    />
                  )}
                </span>
                <span
                  className="action-icon as-link"
                  onClick={() => setShareModal(true)}
                >
                  <FontAwesomeIcon icon={faShareNodes} />
                </span>
              </div>
            </div>
            <h4>{item.tagLine}</h4>

            <div className="address-wrapper">
              {item.address && (
                <p>
                  <FontAwesomeIcon icon={faLocationDot} color="#4A4C56" />{" "}
                  {item.address}
                </p>
              )}

              <div className="row">
                {/* <div className="col-6 mb-3">
                  <span>
                    <FontAwesomeIcon icon={faStar} color="#4A4C56" /> 4.8 (118
                    reviews)
                  </span>
                </div> */}

                {item.capacity && (
                  <div className="col-6 mb-3">
                    <span>
                      <FontAwesomeIcon icon={faUser} color="#4A4C56" />{" "}
                      {item.capacity ? item.capacity : 0} people
                    </span>
                  </div>
                )}
                {item.minHours && (
                  <div className="col-6">
                    <span>
                      <FontAwesomeIcon icon={faClock} color="#4A4C56" />{" "}
                      {item.minHours ? item.minHours : 0} hrs
                    </span>
                  </div>
                )}
                {item.area && (
                  <div className="col-6">
                    <span>
                      <img src={rightAngleImg} alt="" />{" "}
                      {formatArea(item.area)} sqft
                    </span>
                  </div>
                )}
              </div>
            </div>

            <div className="desc-wrapper">
              <h3>About {item.name}</h3>
              <p>
                {descReadMore
                  ? `${String(item.description).substring(0, 450)}...`
                  : `${String(item.description).substring(0, 100)}...`}
              </p>

              <span
                className="read-more-link as-link"
                onClick={() => setDescReadMore(!descReadMore)}
              >
                Read {!descReadMore ? "more" : "less"}
              </span>
            </div>

            <div className="pricing-wrapper">
              <h5>Add details to view total price</h5>
              {hasSpaceRate(item.ratePerHour) ? (
                <h3>{formatSpaceRate(item.ratePerHour, { suffix: "/hr" })}</h3>
              ) : (
                <div className="price-unavailable-block">
                  <span className="price-unavailable-label">
                    {SPACE_RATE_UNAVAILABLE_LABEL}
                  </span>
                  <span className="price-unavailable-help">
                    {SPACE_RATE_UNAVAILABLE_HELP_LONG}
                  </span>
                </div>
              )}
              {item.minHours && <p>{item.minHours} hr minimum</p>}

              {/* <div className="discount-infos">
                <span>8+ hour discount</span>
                <span className="tag">{item.discountHours}% off</span>
              </div> */}
            </div>

            <div className="host-details-wrapper">
              <div className="host-info">
                <img src={defaultUserImg} alt="" />

                <div className="name-details">
                  {item?.user && <h3>Hosted by {item?.user?.name}</h3>}
                  {/* <p>Power Host</p> */}
                </div>
              </div>

              {/* <div className="timing-info">
                <h3>Operating Hours</h3>
                <p>Monday - Sunday (All day 24 hours)</p>
              </div> */}
            </div>

            <Button className="view-details-btn" onClick={() => redirectTo()}>
              View Details
            </Button>
          </div>
        </div>
      </div>

      {shareModal && (
        <ShareSpaceModal
          show={shareModal}
          closeModal={() => setShareModal(false)}
          name={item ? item.name : ""}
          title={`Checkout this awesome place ${item?.name}`}
          content={`${String(item?.description).substring(0, 80)}...`}
          url={`${webSiteUrl}/space/${item.id}`}
        />
      )}
    </Modal>
  );
};

export default SpotDetailsModal;
